import endpoints from "@config/endpoints";
import { getData, getDataWithCache, postDataJSON } from "@services/CommonApiService";
import { toast } from "react-toastify";
import { FACILITY_REFERRAL_API_DETAILS, FACILITY_REFERRAL_ERROR_MESSAGES, FACILITY_API_DETAILS, FACILITY_COMMON_CONSTANTS, FACILITY_ERROR_MESSAGES  } from "./FacilityReferralConstants";

export const getReferredFromInfoByReferralId = async (referralId:any) => {
  try {
       const res = await getData<any>(`${endpoints.getReferredFromInfoByReferralId(referralId)}`);
       if (res && (res.data || res.data.length > 0)) {
        
        return res.data;
    }
  } catch(error:any) {
        toast.error(FACILITY_REFERRAL_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(FACILITY_REFERRAL_API_DETAILS.REFERRED_FROM_DETAILS), {
            position: "top-center"
        });
  }
}

export const getfacilityReferralStatus = async () => {
    try {
      const res = await getData<any>(`${endpoints.getfacilityReferralStatus}`);
      if(res && (res.data || res.data.length > 0)) {
        return res;
      }
    }
   catch(error:any) {
    toast.error(FACILITY_REFERRAL_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(FACILITY_REFERRAL_API_DETAILS.REFERRAL_STATUS), {
        position: "top-center"
    }); 
  }
}

  export const getReferredToInfoByFacilityReferralGroupId = async (groupReferralId:any) => {
    try {
         const res = await getData<any>(`${endpoints.getReferredToInfoByFacilityReferralGroupId(groupReferralId)}`);
         if (res && (res.data || res.data.length > 0)) {

          return res.data;
      }
    } catch(error:any) {
          toast.error(FACILITY_REFERRAL_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(FACILITY_REFERRAL_API_DETAILS.REFERRED_TO_DETAILS), {
              position: "top-center"
          });
    }
  }

export const getRefferedFor = async () => {
    try {
        const res = await getDataWithCache<any>(endpoints.getPNCServiceListByServiceSubCategory);
        if (res && (res.data || res.data.length > 0)) {
            return res.data;
        }
    } catch (error: any) {
        toast.error(FACILITY_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(FACILITY_API_DETAILS.REFFERED_FOR), {
            position: "top-center"
        });
    };
};

export const getServiceType = async (isChild:boolean) => {
    try {
        const res = await getData<any>(`${endpoints.getServiceType(isChild)}`);
        if (res && (res.data || res.data.length > 0)) {
            return res.data;
        }
    } catch (error: any) {
        toast.error(FACILITY_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(FACILITY_API_DETAILS.SERVICE_TYPE), {
            position: "top-center"
        });
    };
};

export const getReasonForReferral = async (serviceTypeId: any) => {
    try {
        const res = await getData<any>(`${endpoints.reasonForReferral(serviceTypeId)}`);
        if (res && (res.data || res.data.length > 0)) {
            return res.data;
        }
    } catch (error: any) {
        toast.error(FACILITY_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(FACILITY_API_DETAILS.REASON_FOR_REFERRAL), {
            position: "top-center"
        });
    };
};

export const getUserDetailsById = async (userId: any) => {
    try {
        const res = await getDataWithCache<any>(`${endpoints.getUserById}/${userId}`);
        if (res && (res.data || res.data.length > 0)) {
            return res.data[0];
        }
    } catch (error: any) {
        toast.error(FACILITY_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(FACILITY_API_DETAILS.USER_ID), {
            position: "top-center"
        });
    };
};

export const getUlb = async (stateId: any) => {
    try {
        const res = await getDataWithCache<any>(`${endpoints.getUlb(stateId)}`);
        if (res && (res.data || res.data.length > 0)) {
            return res.data;
        }
    } catch (error: any) {
        toast.error(FACILITY_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(FACILITY_API_DETAILS.ULB), {
            position: "top-center"
        });
    };
};

export const getSubDistricts = async (districtId: any) => {
    try {
        const res = await getDataWithCache<any>(`${endpoints.getSubDistricts(districtId)}`);
        if (res && (res.data || res.data.length > 0)) {
            return res.data;
        }
    } catch (error: any) {
        toast.error(FACILITY_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(FACILITY_API_DETAILS.DISTRICT), {
            position: "top-center"
        });
    };
};

export const getBlock = async (districtId: any) => {
    try {
        const res = await getDataWithCache<any>(`${endpoints.getBlock(districtId)}`);
        if (res && (res.data || res.data.length > 0)) {
            return res.data;
        }
    } catch (error: any) {
        toast.error(FACILITY_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(FACILITY_API_DETAILS.BLOCK), {
            position: "top-center"
        });
    };
};

export const getVillageByBlockId = async (blockId: any) => {
    try {
        const res = await getDataWithCache<any>(`${endpoints.getVillageByBlockId(blockId)}`);
        if (res && (res.data || res.data.length > 0)) {
            return res.data;
        }
    } catch (error: any) {
        toast.error(FACILITY_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(FACILITY_API_DETAILS.VILLAGE), {
            position: "top-center"
        });
    };
};

export const getWard = async (ulbId: any) => {
    try {
        const res = await getDataWithCache<any>(`${endpoints.getWard(ulbId)}`);
        if (res && (res.data || res.data.length > 0)) {
            return res.data;
        }
    } catch (error: any) {
        toast.error(FACILITY_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(FACILITY_API_DETAILS.WARD), {
            position: "top-center"
        });
    };
};

export const getRuralUrbal = async () => {
    try {
        const res = await getDataWithCache<any>(`${endpoints.getRuralUrbal}`);
        if (res && (res.data || res.data.length > 0)) {
            return res.data;
        }
    } catch (error: any) {
        toast.error(FACILITY_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(FACILITY_API_DETAILS.RURAL_URBAN), {
            position: "top-center"
        });
    };
};

export const getFacilityType = async (userId:any) => {
    try {
        const res = await getDataWithCache<any>(`${endpoints.referredFacilityType(userId)}`);
        if (res && (res.data || res.data.length > 0)) {
            return res.data;
        }
    } catch (error: any) {
        toast.error(FACILITY_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(FACILITY_API_DETAILS.FACILITY_TYPE), {
            position: "top-center"
        });
    };
};

export const facilityForReferral = async (payload: any) => {
    try {
        const res = await postDataJSON<any>(`${endpoints.facilityForReferral}`, payload);
        if (res && (res.data)) {
            return res.data;
        }
    } catch (error: any) {
        toast.error(FACILITY_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(FACILITY_API_DETAILS.FACILITY_FOR_REFERRAL), {
            position: "top-center"
        });
    };
};

export const beneficiaryReferral = async (payload: any) => {
    try {
        const res = await postDataJSON<any>(`${endpoints.beneficiaryReferral}`, payload);
        if (res && (res.data)) {
            toast.success(FACILITY_COMMON_CONSTANTS.REFERRAL_SUCCESS , {
                position: "top-center"
            })
            return res.data;
        }
    } catch (error: any) {
        toast.error(FACILITY_ERROR_MESSAGES.POST_API_ERROR_MESSAGE(FACILITY_API_DETAILS.BENEFICIARY_REFERRAL), {
            position: "top-center"
        });
    };
};

export const getFacilityReferralList = async (benefId: any) => {
    try {
        const res = await getData<any>(`${endpoints.facilityReferralList(benefId)}`);
        if (res && (res.data)) {
            return res.data;
        }
    } catch (error: any) {
        toast.error(FACILITY_ERROR_MESSAGES.GET_API_ERROR_MESSAGE(FACILITY_API_DETAILS.FACILITY_FOR_REFERRAL), {
            position: "top-center"
        });
    };
}

export const changeReferralStatus = async (payload:any,status:string) => {
    try {
        const res = await postDataJSON<any>(`${endpoints.changeReferralStatus}`,payload);
        if (res && (res.data)) {
            let sucessMessage = '';
            if(status === 'managed') {
                sucessMessage = FACILITY_COMMON_CONSTANTS.REFERRAL_MANAGED;
            } else if(status === 'rejected') {
                sucessMessage = FACILITY_COMMON_CONSTANTS.REFERRAL_REJECTED
            }
            toast.success(sucessMessage , {
                position: "top-center"
            })
            return res.data;
        }
    }catch (error: any) {
        toast.error(FACILITY_ERROR_MESSAGES.POST_API_ERROR_MESSAGE(FACILITY_API_DETAILS.BENEFICIARY_REFERRAL), {
            position: "top-center"
        });
    };
}